import React from "react";
import "../styles/Project.css";

function Projects() {
  return (
    <div className="project-page">

      {/* HERO SECTION */}
      <div className="project-hero">
        <h1>Our Projects</h1>
        <p>Explore our latest interior design transformations</p>
      </div>

      {/* PROJECT GALLERY */}
      <section className="project-section container">

        <h2 className="project-title">3D Design by Onsite Interiors</h2>

        <div className="project-grid">

          <div className="project-card">
            <img src="/projects/p1.jpeg" alt="Kitchen Design" />
             <div className="project-overlay">
               <h3>Modern Kitchen</h3>
               <p>Elegant modular kitchen with premium finishes.</p>
            </div>
           </div>

          <div className="project-card">
            <img src="/projects/p2.jpeg" alt="Bedroom Design" />
            <div className="project-overlay">
              <h3>Luxury Bedroom</h3>
              <p>Comfortable and stylish bedroom interiors.</p>
            </div>
          </div>

          <div className="project-card">
            <img src="/projects/p3.jpeg" alt="Living Room" />
            <div className="project-overlay">
              <h3>Living Room</h3>
              <p>Luxury living room with modern furniture.</p>
            </div>
          </div>

          <div className="project-card">
            <img src="/projects/p4.jpeg" alt="Dining Area" />
            <div className="project-overlay">
              <h3>Dining Area</h3>
              <p>Stylish dining space with warm lighting.</p>
            </div>
          </div>

          <div className="project-card">
            <img src="/projects/p5.jpeg" alt="Office Interior" />
            <div className="project-overlay">
              <h3>Office Interior</h3>
              <p>Professional office space with modern design.</p>
            </div>
          </div>

        </div>

      </section>

    </div>
  );
}

export default Projects;